/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { publicDataRemovalRequestDataStatusSchema } from './PublicDataRemovalRequestDataStatusSchema'

export const publicDataRemovalRequestDataSchema = z.object({
	status: publicDataRemovalRequestDataStatusSchema,
	companyName: z.string().nullable(),
	companyLogoUrl: z.string().nullable(),
	message: z.string().nullable(),
})

export type PublicDataRemovalRequestDataSchema = z.infer<typeof publicDataRemovalRequestDataSchema>
